import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpsertAllowedCustomersMutationVariables = Types.Exact<{
  allowedCustomersObj: Array<Types.Usertocustomers_Insert_Input> | Types.Usertocustomers_Insert_Input;
}>;


export type UpsertAllowedCustomersMutation = { __typename?: 'mutation_root', insert_usertocustomers?: { __typename?: 'usertocustomers_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'usertocustomers', user_id: number, customer_id: number }> } | null };


export const UpsertAllowedCustomersDocument = gql`
    mutation upsertAllowedCustomers($allowedCustomersObj: [usertocustomers_insert_input!]!) {
  insert_usertocustomers(
    objects: $allowedCustomersObj
    on_conflict: {constraint: usertocustomers_user_id_customer_id_key, update_columns: []}
  ) {
    affected_rows
    returning {
      user_id
      customer_id
    }
  }
}
    `;
export type UpsertAllowedCustomersMutationFn = Apollo.MutationFunction<UpsertAllowedCustomersMutation, UpsertAllowedCustomersMutationVariables>;

/**
 * __useUpsertAllowedCustomersMutation__
 *
 * To run a mutation, you first call `useUpsertAllowedCustomersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAllowedCustomersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAllowedCustomersMutation, { data, loading, error }] = useUpsertAllowedCustomersMutation({
 *   variables: {
 *      allowedCustomersObj: // value for 'allowedCustomersObj'
 *   },
 * });
 */
export function useUpsertAllowedCustomersMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAllowedCustomersMutation, UpsertAllowedCustomersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAllowedCustomersMutation, UpsertAllowedCustomersMutationVariables>(UpsertAllowedCustomersDocument, options);
      }
export type UpsertAllowedCustomersMutationHookResult = ReturnType<typeof useUpsertAllowedCustomersMutation>;
export type UpsertAllowedCustomersMutationResult = Apollo.MutationResult<UpsertAllowedCustomersMutation>;
export type UpsertAllowedCustomersMutationOptions = Apollo.BaseMutationOptions<UpsertAllowedCustomersMutation, UpsertAllowedCustomersMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/userManagement/queries/upsertAllowedCustomers.mutation.gql}
 */
export async function upsertAllowedCustomers(
  variables: UpsertAllowedCustomersMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpsertAllowedCustomersMutation['insert_usertocustomers']>
export async function upsertAllowedCustomers(
  variables: UpsertAllowedCustomersMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpsertAllowedCustomersMutation>
export async function upsertAllowedCustomers(
  variables: UpsertAllowedCustomersMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpsertAllowedCustomersMutation['insert_usertocustomers'] | UpsertAllowedCustomersMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpsertAllowedCustomersMutation>(
    UpsertAllowedCustomersDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_usertocustomers
}